import React, { FC, HTMLAttributes, RefCallback, RefObject } from 'react';
// @ts-ignore
import BrowserSymbol from 'svg-baker-runtime/browser-symbol';
// @ts-ignore
import { assign } from 'es6-object-assign';
import { addSpriteSymbol, useIsomorphicLayoutEffect } from '../sprite';
import { SvgIcon } from '../SvgIcon';

const viewBox = '0 0 20 20';
const id = 'comment_outline_20';
const content = '<symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" id="comment_outline_20"><path clip-rule="evenodd" d="M6.426 18.886A1.5 1.5 0 015.5 17.5v-2c-.37 0-.719-.004-1.019-.028-.376-.03-.805-.102-1.234-.32a3.2 3.2 0 01-1.398-1.4c-.219-.428-.29-.857-.32-1.233-.03-.346-.029-.756-.029-1.19V6.67c0-.433 0-.843.028-1.189.03-.376.102-.805.32-1.234a3.2 3.2 0 011.4-1.398c.428-.219.857-.29 1.233-.32.346-.03.756-.029 1.19-.029h8.659c.433 0 .843 0 1.189.028.376.03.805.102 1.234.32a3.2 3.2 0 011.398 1.4c.219.428.29.857.32 1.233.03.346.03.756.029 1.19v4.659c0 .433 0 .843-.028 1.189-.03.376-.102.805-.32 1.234a3.2 3.2 0 01-1.4 1.398c-.428.219-.857.29-1.233.32-.346.03-.756.03-1.19.029h-3.166c-.03 0-.05.009-.071.03l-3.031 3.03a1.5 1.5 0 01-1.635.326zM7 15.12c0-.392 0-.588-.076-.738a.7.7 0 00-.306-.306C6.468 14 6.272 14 5.88 14h-.16c-.952 0-1.428 0-1.792-.185a1.7 1.7 0 01-.743-.743C3 12.708 3 12.232 3 11.28V6.72c0-.952 0-1.428.185-1.792a1.7 1.7 0 01.743-.743C4.292 4 4.768 4 5.72 4h8.56c.952 0 1.428 0 1.792.185.32.163.58.423.743.743.185.364.185.84.185 1.792v4.56c0 .952 0 1.428-.185 1.792a1.7 1.7 0 01-.743.743c-.364.185-.84.185-1.792.185h-3.117c-.245 0-.367 0-.482.028a.998.998 0 00-.29.12c-.1.061-.187.148-.36.32L7 17.5z" fill="currentColor" fill-rule="evenodd" /></symbol>';

let isMounted = false;
function mountIcon() {
  if (!isMounted) {
    addSpriteSymbol(new BrowserSymbol({
      id: id,
      viewBox: viewBox,
      content: content,
    }));

    isMounted = true;
  }
}

export interface Icon20CommentOutlineProps extends HTMLAttributes<HTMLDivElement> {
  fill?: string;
  width?: number;
  height?: number;
  getRootRef?: RefCallback<HTMLDivElement> | RefObject<HTMLDivElement>;
}

const Icon20CommentOutline: FC<Icon20CommentOutlineProps> = (props) => {
  useIsomorphicLayoutEffect(() => {
    mountIcon();
  }, []);

  return React.createElement(SvgIcon, assign({}, props, {
    viewBox: viewBox,
    id: id,
    width: !isNaN(props.width) ? +props.width : 20,
    height: !isNaN(props.height) ? +props.height : 20,
  }));
};

(Icon20CommentOutline as any).mountIcon = mountIcon;

export default Icon20CommentOutline;
